import { Button, LinearProgress, MenuItem } from '@material-ui/core';
import Icon from '@mdi/react';
import styled from 'styled-components';
import IconSize from '../../../../lib/IconSize';
import { defaultMuiTheme } from '../../../../styles/MaterialTheme';
import TooltippedIconButton from '../../../Buttons/components/TooltippedIconButton';
export const SwitchToContainer = styled.div `
    border: 1px solid ${({ theme, $isError }) => ($isError ? theme.colors.error : theme.colors.primary)};
    border-radius: 4px;
    min-height: 3rem;
    align-items: center;
    justify-content: space-between;
    display: flex;
    margin: 1rem;
    padding-right: 1rem;
    ${defaultMuiTheme.breakpoints.down(600)} {
        flex-direction: column;
        padding-bottom: 1rem;
    }
`;
export const NotificationContainer = styled.div `
    display: flex;
    margin: 1rem 0 1rem 1rem;
`;
export const NotificationIcon = styled(Icon) `
    color: ${({ theme, $isError }) => ($isError ? theme.colors.error : theme.colors.primary)};
`;
export const Notification = styled.div `
    margin-left: 1rem;
    display: flex;
    color: #0d3c61;
    font-size: 14px;
`;
export const NotificationButton = styled(Button) `
    min-width: ${({ $minWidth }) => ($minWidth ? $minWidth : 170)}px;
    color: ${({ theme, $isError }) => ($isError ? theme.colors.error : theme.colors.primary)};
`;
export const StyledMenuItem = styled(MenuItem) `
    display: flex;
    align-items: center;
    color: ${(props) => props.theme.colors.primary};

    svg {
        width: ${IconSize.Small};
        margin-right: 0.5rem;
    }
`;
export const Divider = styled.hr `
    border: 0;
    border-bottom: 1px solid ${(props) => props.theme.colors.border};
    margin: 8px 0;
`;
export const UninstallDialog = styled.div `
    display: flex;
    flex-direction: column;
    padding
`;
export const UninstallDescription = styled.div `
    display: flex;
    font-size: 1rem;
    letter-spacing: 0.09px;
    line-height: 1.5rem;
    color: ${(props) => props.theme.colors.textSecondary};
`;
export const RemoveCacheDialog = styled.div `
    display: flex;
    margin-top: 1.5rem;
`;
export const RemoveCacheSubDialog = styled.div `
    font-size: 14.22px;
    letter-spacing: 0.1px;
    line-height: 20px;
    color: ${(props) => props.theme.colors.textTertiary};
`;
export const DotMenuButton = styled(TooltippedIconButton) `
    padding: 0;
    height: initial;

    min-height: initial;
    min-width: 40px;
    margin-right: 1rem;
`;
export const LabContainer = styled.div `
    margin-top: 2rem;
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: 4px;
`;
export const LabMetaContainer = styled.div `
    margin-top: 1rem;
    display: flex;
    padding-bottom: 1rem;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
`;
export const LabDescriptionContainer = styled.div `
    display: flex;
    flex-direction: column;
    width: 100%;
`;
export const FlaskIcon = styled(Icon) `
    color: ${({ theme }) => theme.colors.textTertiary};
    margin: 0 1rem 0 1rem;
`;
export const RequirementsIcon = styled(Icon) `
    color: ${({ theme }) => theme.colors.textTertiary};
    margin-right: 0.5rem;
`;
export const VMIcon = styled(Icon) `
    color: ${({ theme }) => theme.colors.textTertiary};
`;
export const LaunchIcon = styled(Icon) `
    color: ${({ theme, $disabled }) => ($disabled ? theme.colors.actionDisabled : theme.colors.primary)};
`;
export const LabTitle = styled.div `
    color: ${({ theme }) => theme.colors.text};
    font-size: 1rem;
    font-weight: 500;
    letter-spacing: 0.06px;
    line-height: 1.5rem;
`;
export const LabDescription = styled.div `
    color: ${({ theme }) => theme.colors.textTertiary};
    font-size: 14.22px;
    line-height: 20px;
`;
export const LabRequirementsContainer = styled.div `
    margin-top: 0.5rem;
    display: flex;
    justify-content: space-between;
    width: 100%;
`;
export const VirtualMachines = styled.div `
    display: flex;
    flex-direction: column;
    padding: 1rem;
`;
export const VirualMachine = styled.div `
    display: flex;
    margin-top: 1rem;
    margin-bottom: 10px;
    justify-content: space-between;
`;
export const VirualMachineMeta = styled.div `
    display: flex;
    margin-left: 1rem;
    flex-direction: column;
`;
export const VirualMachineRequirements = styled.div `
    display: flex;
    margin-top: 4px;
`;
export const FlexContainer = styled.div `
    display: ${({ $hidden }) => ($hidden ? 'none' : 'flex')};
`;
export const Requirements = styled.div `
    display: flex;
    flex-direction: column;
    font-weight: 500;
    font-size: 14.22px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.textSecondary};
`;
export const Requirement = styled.div `
    font-weight: initial;
    color: ${({ theme }) => theme.colors.textTertiary};
`;
export const VirualMachineRequirement = styled.div `
    color: ${({ theme }) => theme.colors.textTertiary};
    display: flex;
    font-size: 14.22px;
    letter-spacing: 0.1px;
    line-height: 20px;
    margin-right: 0.5rem;
`;
export const LabHeader = styled.div `
    justify-content: space-between;
    display: flex;
`;
export const InstalledContainer = styled.div `
    display: flex;
    font-size: 1rem;
    font-weight: 500;
    margin: 0.5rem 0 0 0;
    letter-spacing: 0.09px;
    line-height: 1.5rem;
    color: ${({ theme }) => theme.colors.text};
`;
export const CheckmarkIcon = styled(Icon) `
    color: ${({ theme }) => theme.colors.success};
    margin-right: 0.5rem;
`;
export const ProgressContainer = styled.div `
    display: flex;
    flex-direction: column;
    min-width: 270px;
    width: 
    margin: 0.5rem 0 0 0;
    color: ${({ theme }) => theme.colors.textSecondary};

    font-size: 14.22px;
    letter-spacing: 0.1px;
    line-height: 20px;
`;
export const DownloadContainer = styled.div `
    display: flex;
    flex-direction: column;
`;
export const ProgressTextContainer = styled.div `
    display: flex;
`;
export const ImportContainer = styled.div `
    display: flex;
    flex-direction: column;
`;
export const StyledProgressBar = styled(LinearProgress) `
    height: 4px;
    margin: 0.5rem 0 0.5rem 0;
    width: 100%;
    bar: {
        opacity: 0.25;
        border-radius: 20px;
    }
`;
//# sourceMappingURL=lab.styles.js.map